import { Modal } from '@wiggui/ds/Modal'
import { Text } from '@wiggui/ds/Text'
import { Button } from '@wiggui/ds/Button'
import { OptionButton } from '@wiggui/ds/OptionButton'
import { MdClose } from 'react-icons/md'
import { useModalDescriptionTooLongStore } from '../../store/modals/modal-description-too-long'
import { WarningSvg } from '../../svg/WarningSvg'

export const ModalDescriptionTooLong = () => {
  const [isOpen, setIsOpen, primaryAction, secondaryAction, isLoading] =
    useModalDescriptionTooLongStore((state) => [
      state?.isOpen,
      state?.setIsOpen,
      state?.primaryAction,
      state?.secondaryAction,
      state?.isLoading
    ])
  return (
    <Modal
      isOpen={isOpen}
      className="md:w-[620px] bg-surface-white"
      onClose={() => setIsOpen(false)}
      closeOnOutsideClick={true}
      enableBgBlur
    >
      <Modal.Header className="flex justify-between items-center w-full px-6 py-1 border-b border-strokes">
        <p className="text-lg font-semibold">
          Oops... descripción de ficha muy larga
        </p>
        <OptionButton
          className="flex justify-center items-center w-12 h-12 p-3"
          onClick={() => setIsOpen(false)}
        >
          <MdClose className="w-6 h-6" />
        </OptionButton>
      </Modal.Header>
      <Modal.Body className="flex flex-col w-full justify-center items-center gap-6 p-6">
        <WarningSvg />
        <Text align="center" className="text-sm font-normal">
          La descripción de la propiedad supera la capacidad de impresión máxima
          de la ficha por lo que te mostraremos las primeras 20 líneas, puedes
          editar este campo en la opción de{' '}
          <b className="font-semibold">Editar y descargar</b> y generar una
          descripción nueva.
        </Text>
      </Modal.Body>
      <Modal.Footer className="flex items-center gap-3 w-full px-6 py-3 border-t border-strokes">
        <Button onClick={secondaryAction} fullWidth variant="terciary">
          Editar
        </Button>
        <Button
          onClick={primaryAction}
          isLoading={isLoading}
          fullWidth
          variant="secondary"
        >
          Descargar original
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
